import { Deserializer } from "jsonapi-serializer";
import { ExpiryReason } from "../models/ExpiryReason";
import { genericError } from "../models/GenericError";
import { ListQuery } from "../models/ListQuery";
import { ExpiryReasonWrapper } from "../models/wrappers/ExpiryReasonWrapper";
import { APIConnector } from './api/APIConnector';
import { createPagination } from "./utilities/paginationBuilder";
import { processServerError, getConstraintViolation } from "./utilities/ServiceError";
import { createPartialURL, getFilterClause } from "./utilities/urlBuilder";
const apiConnector = new APIConnector();

const DAYS = 1; // erUnits of 1 means Days
const WEEKS = 2; // erUnits of 1 means Weeks, whereas 3 means Months


export const getExpiryReasons = async (listParameters?: ListQuery): Promise<ExpiryReasonWrapper> => {
    try {
        const filter: string = getFilterClause(listParameters?.filters, listParameters?.searchTerm)
        const partialURL = createPartialURL(listParameters?.goToPage, listParameters?.pageSize, listParameters?.sortBy, filter);
        const url = `expiryReason${partialURL}`.replace('&', '?'); //HACK: I am not sure if this is a better way of doing this.

        const response = await apiConnector.fetchData(url);
        const json = await response.json();
        const pagination = createPagination(json.meta);

        return new Promise((resolve, reject) => {
            if (json.errors) {
                return reject({status: response.status, message: getConstraintViolation(json.errors[0].detail) })
            }

            new Deserializer().deserialize(json, (error: any, data: any[]) => {
                if (error) {
                    return reject({status: response.status, message: genericError });
                }

                const rows: ExpiryReason[] = data.map((expiryReason): ExpiryReason => {
                    return {
                        id: expiryReason['id'],
                        name: expiryReason['er-name'],
                        duration: convertDuration(expiryReason['er-duration'], expiryReason['er-units']).toString(),
                        durationWarning: convertDuration(expiryReason['er-duration-warn'], DAYS).toString(),
                        isDefault: expiryReason['is-default']
                    }
                })

                return resolve({ rows, pagination: pagination });
            })
        });
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error));
        });
    }
}

/**
 * For duration we determine whether it's Days/Weeks/Months based on erUnits value.
 * For durationWarn we always use Days as the unit of measurement. With zero meaning its disabled. I.e. no warning.
 * @param duration
 * @param units
 */
function convertDuration(duration: number, units: number) {
    const unitsLabel = units == DAYS ? 'Days' : units == WEEKS ? 'Weeks' : 'Months';
    const durationTxt = (duration > 0) ? `${duration} ` + unitsLabel : '--';
    return durationTxt;
}
